/* Generated: every handoff image (assets/imagery/*.png → 1600px JPEG). Keys are the original .png names. */
import img_clinician_portrait from '../../../images/everywhere/v2/clinician-portrait.jpg';
import img_coll_energy_iron_core_360_free_01 from '../../../images/everywhere/v2/coll-energy-iron__core-360-free-01.jpg';
import img_coll_immunity from '../../../images/everywhere/v2/coll-immunity.jpg';
import img_coll_mens_health from '../../../images/everywhere/v2/coll-mens-health.jpg';
import img_coll_sexual_health_sexual_health_free_01 from '../../../images/everywhere/v2/coll-sexual-health__sexual-health-free-01.jpg';
import img_coll_womens_health_core_360_paid_06 from '../../../images/everywhere/v2/coll-womens-health__core-360-paid-06.jpg';
import img_lab_visit_female from '../../../images/everywhere/v2/lab-visit-female.jpg';
import img_lab_visit_male from '../../../images/everywhere/v2/lab-visit-male.jpg';
import img_lab_visit_neutral from '../../../images/everywhere/v2/lab-visit-neutral.jpg';
import img_new_apob from '../../../images/everywhere/v2/new-apob.jpg';
import img_new_ferritin_core_360_paid_01 from '../../../images/everywhere/v2/new-ferritin__core-360-paid-01.jpg';
import img_new_insulin_core_360_paid_04 from '../../../images/everywhere/v2/new-insulin__core-360-paid-04.jpg';
import img_new_testosterone_core_360_paid_05 from '../../../images/everywhere/v2/new-testosterone__core-360-paid-05.jpg';
import img_new_tsh_core_360_paid_02 from '../../../images/everywhere/v2/new-tsh__core-360-paid-02.jpg';
import img_spot_allergy_skin_allergy_paid_02 from '../../../images/everywhere/v2/spot-allergy__skin-allergy-paid-02.jpg';
import img_spot_blood from '../../../images/everywhere/v2/spot-blood.jpg';
import img_spot_heart_core_360_free_05_web from '../../../images/everywhere/v2/spot-heart__core-360-free-05-web.jpg';
import img_spot_immunity from '../../../images/everywhere/v2/spot-immunity.jpg';
import img_spot_inflammation from '../../../images/everywhere/v2/spot-inflammation.jpg';
import img_spot_kidney from '../../../images/everywhere/v2/spot-kidney.jpg';
import img_spot_liver from '../../../images/everywhere/v2/spot-liver.jpg';
import img_spot_longevity_heart_metabolic_free_01 from '../../../images/everywhere/v2/spot-longevity__heart-metabolic-free-01.jpg';
import img_spot_neutral_hormone_free_01 from '../../../images/everywhere/v2/spot-neutral__hormone-free-01.jpg';
import img_spot_sleep from '../../../images/everywhere/v2/spot-sleep.jpg';
import img_spot_sti_sexual_health_free_02 from '../../../images/everywhere/v2/spot-sti__sexual-health-free-02.jpg';
import img_spot_sugar_core_360_paid_04 from '../../../images/everywhere/v2/spot-sugar__core-360-paid-04.jpg';
import img_spot_testosterone from '../../../images/everywhere/v2/spot-testosterone.jpg';
import img_spot_thyroid_core_360_free_01 from '../../../images/everywhere/v2/spot-thyroid__core-360-free-01.jpg';
import img_spot_urinary from '../../../images/everywhere/v2/spot-urinary.jpg';
import img_spot_vitamins_immune_inflammation_free_02 from '../../../images/everywhere/v2/spot-vitamins__immune-inflammation-free-02.jpg';

const IMAGES: Record<string, string> = {
  'clinician-portrait.png': img_clinician_portrait,
  'coll-energy-iron__core-360-free-01.png':
    img_coll_energy_iron_core_360_free_01,
  'coll-immunity.png': img_coll_immunity,
  'coll-mens-health.png': img_coll_mens_health,
  'coll-sexual-health__sexual-health-free-01.png':
    img_coll_sexual_health_sexual_health_free_01,
  'coll-womens-health__core-360-paid-06.png':
    img_coll_womens_health_core_360_paid_06,
  'lab-visit-female.png': img_lab_visit_female,
  'lab-visit-male.png': img_lab_visit_male,
  'lab-visit-neutral.png': img_lab_visit_neutral,
  'new-apob.png': img_new_apob,
  'new-ferritin__core-360-paid-01.png': img_new_ferritin_core_360_paid_01,
  'new-insulin__core-360-paid-04.png': img_new_insulin_core_360_paid_04,
  'new-testosterone__core-360-paid-05.png':
    img_new_testosterone_core_360_paid_05,
  'new-tsh__core-360-paid-02.png': img_new_tsh_core_360_paid_02,
  'spot-allergy__skin-allergy-paid-02.png':
    img_spot_allergy_skin_allergy_paid_02,
  'spot-blood.png': img_spot_blood,
  'spot-heart__core-360-free-05-web.png': img_spot_heart_core_360_free_05_web,
  'spot-immunity.png': img_spot_immunity,
  'spot-inflammation.png': img_spot_inflammation,
  'spot-kidney.png': img_spot_kidney,
  'spot-liver.png': img_spot_liver,
  'spot-longevity__heart-metabolic-free-01.png':
    img_spot_longevity_heart_metabolic_free_01,
  'spot-neutral__hormone-free-01.png': img_spot_neutral_hormone_free_01,
  'spot-sleep.png': img_spot_sleep,
  'spot-sti__sexual-health-free-02.png': img_spot_sti_sexual_health_free_02,
  'spot-sugar__core-360-paid-04.png': img_spot_sugar_core_360_paid_04,
  'spot-testosterone.png': img_spot_testosterone,
  'spot-thyroid__core-360-free-01.png': img_spot_thyroid_core_360_free_01,
  'spot-urinary.png': img_spot_urinary,
  'spot-vitamins__immune-inflammation-free-02.png':
    img_spot_vitamins_immune_inflammation_free_02,
};

/** Resolve a catalog image name (`*.png` in the handoff) to the bundled asset. */
export const v2Image = (name: string): string =>
  IMAGES[name] || IMAGES[name.replace(/\.jpg$/, '.png')] || '';

export default IMAGES;
